import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import { countryOptions, stateOptions } from "layouts/views/common/options";
import { SelectField, TitleButton } from "ui-components/Form";

import { FormTitle, TitleField, Text, SwitchField } from "ui-components/Form";

function ConsigneeInfo({ formRender, control, errors, getValues, setValue, mode = "ADD" }) {
  const applyBilling = () => {
    const {
      billCompany,
      billAddress1,
      billAddress2,
      billPostcode,
      billCity,
      billState,
      billCountry,
      billPhoneNo,
      billFaxNo,
    } = getValues();
    setValue("shipCompany", billCompany);
    setValue("shipAddress1", billAddress1);
    setValue("shipAddress2", billAddress2);
    setValue("shipPostcode", billPostcode);
    setValue("shipCity", billCity);
    setValue("shipState", billState);
    setValue("shipCountry", billCountry);
    setValue("shipPhoneNo", billPhoneNo);
    setValue("shipFaxNo", billFaxNo);
  };
  return (
    <MDBox>
      <FormTitle title={mode === "EDIT" ? "Edit Consignee Information" : "Consignee Information"} />
      <MDBox mt={1.625}>
        {formRender.map((rows, i) => (
          <Grid container spacing={3} key={i}>
            {rows.map((property, index) => {
              const { disabled, editable, size, ...data } = property;
              const xs = size ? size : 12 / rows.length;
              const fieldProps = {
                ...data,
                control,
                errors,
                ...(disabled && { disabled }),
                ...(mode === "EDIT" && editable === false && { disabled: true }),
              };
              let renderField;
              switch (data.type) {
                case "text":
                case "number":
                  renderField = <Text field={fieldProps} />;
                  break;
                case "switch":
                  renderField = <SwitchField field={fieldProps} />;
                  break;
                case "select":
                  let options = [];
                  switch (fieldProps.name) {
                    case "billState":
                    case "shipState":
                      options = stateOptions;
                      break;
                    case "billCountry":
                    case "shipCountry":
                      options = countryOptions;
                      break;
                  }
                  renderField = <SelectField field={fieldProps} options={options} />;
                  break;
                case "title":
                  renderField = <TitleField label={data.label} />;
                  break;
                case "button":
                  renderField = (
                    <TitleButton label="Apply Billing To Shipping" onClick={applyBilling} />
                  );
                  break;
              }

              return (
                <Grid item xs={xs} key={index}>
                  {renderField}
                </Grid>
              );
            })}
          </Grid>
        ))}
      </MDBox>
    </MDBox>
  );
}

export default ConsigneeInfo;
